import {
  getAllRegex,
  getAllMaxLength,
  getAllNonMandatoryFields,
  getAllFieldErrors,
  getFieldLabels,
  getFieldPlaceholders,
  getFieldNotes,
  getFieldExt,
} from './index'

const email = /^[a-zA-Z0-9]+((.|-|\+|_)[a-zA-Z0-9]+)*@[a-zA-Z0-9]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,4})?$/

const THEME_CONFIG = {
  ...window.appData,
}

export const regex = {
  email: email,
  ...getAllRegex(THEME_CONFIG.fieldsSet),
}

export const length = {
  ...getAllMaxLength(THEME_CONFIG.fieldsSet),
}
export const nonMandatoryFields = {
  ...getAllNonMandatoryFields(THEME_CONFIG.fieldsSet),
}

export const errors = {
  ...getAllFieldErrors(THEME_CONFIG.fieldsSet),
}

export const fieldLabels = {
  ...getFieldLabels(THEME_CONFIG.fieldsSet),
}

export const fieldPlaceholder = {
  ...getFieldPlaceholders(THEME_CONFIG.fieldsSet),
}
export const fieldNotes = {
  ...getFieldNotes(THEME_CONFIG.fieldsSet),
}
export const fieldExt = {
  ...getFieldExt(THEME_CONFIG.fieldsSet),
}

export const checkValues = (formFields, optionalFields = {}) => {
  let error = {}
  let isEmpty = false
  let isValid = true
  Object.keys(formFields).forEach((formField) => {
    if (!optionalFields[formField]) {
      if (regex[formField]) {
        const _regex = new RegExp(regex[formField])
        const regexTest = _regex.test(formFields[formField].trim())
        if (!regexTest) {
          isValid = false
          error[formField] = errors[formField]?.format || 'Invalid format'
        }
      }
      if (length[formField]) {
        if (length[formField] !== 524288 && formFields[formField].length !== length[formField]) {
          isValid = false
          error[formField] = errors[formField]?.length || `${length[formField]} characters required`
        }
      }
      if (Array.isArray(formFields[formField]) && !formFields[formField].length) {
        if (!nonMandatoryFields.hasOwnProperty(formField)) {
          isValid = false
          isEmpty = true
          error[formField] = 'Field is required'
        }
      }
      if (!formFields[formField]) {
        if (!nonMandatoryFields.hasOwnProperty(formField)) {
          isValid = false
          isEmpty = true
          error[formField] = `Field is required`
        }
      }
    }
  })
  return { isValid, isEmpty, error }
}

export const uniqueIDRegex = {
  Numeric: /^[0-9]*$/,
  Alphanumeric: /^([0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-zA-Z0-9]*$/
}

export const onChangeRegex = {
  Numeric: /^[0-9]*$/,
  Alphanumeric: /^[a-zA-Z0-9]*$/
}
